import React, { useState } from "react";
import { setTitle } from "../helpers/MetaTag";
import MonthlyGoalSection from "../components/sections/MonthlyGoalSection";
import CalenderLayout from "../components/sections/CalenderLayout";
import moment from "moment";

const MonthlyGoal = () => {
  setTitle("Journal 365 | Monthly Goal");
  const [currentYear, setCurrentYear] = useState(new Date().getFullYear());
  const [selectedMonth, setSelectedMonth] = useState(new Date().getMonth());
  const calender = {
    today: moment(new Date()).format("DD"),
    currentMonth: new Date().getMonth(),
  };
  const [selectedYear, setSelectedYear] = useState(
    currentYear ? currentYear : ""
  );

  return (
    <>
      <CalenderLayout
        currentYear={currentYear}
        selectedMonth={selectedMonth}
        selectedYear={selectedYear}
        setCurrentYear={setCurrentYear}
        setSelectedYear={setSelectedYear}
        setSelectedMonth={setSelectedMonth}
      >
        <div className="p-5 bg-white rounded-md">
          <MonthlyGoalSection
            selectedMonth={selectedMonth}
            selectedYear={selectedYear}
            currentYear={currentYear}
            calender={calender}
          />
        </div>
      </CalenderLayout>
    </>
  );
};

export default MonthlyGoal;
